// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___6bzP","type":"styles_type__1IUL6","choices":"styles_choices__2TcSb"};